module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC1JREFUOI1jZMAN/qPxGbEpYsJjAFFg1ABIyKKHNn1dMPAGYE1dUDCaEullAAAi0gMdELO4MAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/icons/png/plus-2x.png
// module id = 739
// module chunks = 0